// Manav rachna university 

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const universityBgImage = imageBaseUrl + "International-Relation/University/ManavRachna-University.jpg";

const greater_noida = imageBaseUrl + "International-Relation/University/Noida.png";

const middleEast = imageBaseUrl + "International-Relation/University/fee-structure/Middle_East.zip";
const africa = imageBaseUrl + "International-Relation/University/fee-structure/Africa.zip";


const k1 = imageBaseUrl + "universityKnow/k1.png";
const k2 = imageBaseUrl + "universityKnow/k2.png";
const k3 = imageBaseUrl + "universityKnow/k3.png";
const k5 = imageBaseUrl + "universityKnow/k5.png";
const k6 = imageBaseUrl + "universityKnow/k6.png";

export const manavRachnaUniversityJson = {
  BannerData: {
    heading: "Manav Rachna University",
    backgroundImage: universityBgImage,
    content: (
      <>
        Manav Rachna University is a leading educational institution in India,
        known for its excellence in higher education, research, and innovation.
        Established under Manav Rachna Educational Institutions (MREI), it
        offers
        <b> 100+ programs</b> across disciplines like engineering, management,
        law, applied sciences, and healthcare. The university is recognized for
        its
        <b>
          {" "}
          state-of-the-art infrastructure, industry collaborations, and global
          partnerships.{" "}
        </b>
        With <b> over 36,000 alumni and 500+ recruiters,</b> it provides strong
        <b> placement and internship opportunities. </b> Accredited by{" "}
        <b> NAAC and NBA, </b>
        it emphasizes{" "}
        <b> skill development, entrepreneurship, and holistic learning, </b>
        making it a preferred choice for students seeking{" "}
        <b> quality education with global exposure.</b>
      </>
    ),
  },

  // University Details
  universityDetails: [
    {
      id: 1,
      title: "Name",
      subtitle: "Manav Rachna University (MRU)",
      image: imageBaseUrl + "universityinfo/1.png",
    },
    {
      id: 2,
      title: "Location",
      subtitle: "Faridabad, Haryana, India",
      image: imageBaseUrl + "universityinfo/2.png",
    },
    {
      id: 3,
      title: "Founded",
      subtitle:
        "2004 (as Manav Rachna College of Engineering), became a university in 2014",
        image: imageBaseUrl + "universityinfo/3.png",
    },
    {
      id: 4,
      title: "Type",
      subtitle: "Private University",
      image: imageBaseUrl + "universityinfo/4.png",
    },
    {
      id: 5,
      title: "Total Enrollment",
      subtitle: "Approximately 7,000 students",
      image: imageBaseUrl + "universityinfo/5.png",
    },
    {
      id: 6,
      title: "International Students",
      subtitle: "Varies, students from over 13 countries",
      image: imageBaseUrl + "universityinfo/6.png",
    },
    {
      id: 7,
      title: "Website",
      subtitle: "Strengthening international recognition and credibility",
      image: imageBaseUrl + "universityinfo/7.png",
      url: "https://manavrachna.edu.in/mru",
    },
  ],

  WhyChooseThisUniversityPage:[
    { id: 1, rank: "NAAC A++", title: <><b> NAAC A++ & NBA </b> Accredited</> },
    { id: 2, rank: "2nd Ranked", title: <><b>Ranked 2nd </b> in Haryana among Outlook <b>India's Top 100 </b> Private Engineering Institutes (2022)</> },
    { id: 3, rank: "QS I-Gauge", title: <>Holds a <b>QS I-Gauge</b> overall Gold rating</> },
  ],

  feeStructure: [
      { label: "Africa", value: "Africa", pdfFile: africa },
      { label: "Middle East", value: "Middle East", pdfFile: middleEast},
    ],

KnowMore:[
  {
    title: "Campus Life",
    img: k1, 
    url: "https://manavrachna.edu.in/discover/life-at-manav-rachna",
  },
  {
    title: "How to Apply",
    img: k2, 
    url: "https://manavrachna.edu.in/mru/admissions/admission-process",
  },
  {
    title: "International Students",
    img: k3, 
    url: "https://manavrachna.edu.in/admissions/international-admissions",
  },

  {
    title: "Accommodation",
    img: k5, 
    url: "https://manavrachna.edu.in/mriirs/life/hostel-facility",
  },
  {
    title: "Brochure",
    img: k6, 
    url: "https://manavrachna.edu.in/admissions/download-brochure",
  },
],

Location:{
    header:"GREATER NOIDA",
    image: greater_noida,
    content: (<>Greater Noida is rapidly emerging as a prime destination for international students, offering a perfect blend of quality education, career opportunities, and an excellent standard of living.
<br></br>
<br></br>
<ul style={{"margin-left": "20px"}}>
  <li><b>Top Universities</b></li>
  <li><b>Career Hub</b></li>
<li><b>Vibrant Lifestyle</b></li>
<li><b>Great Connectivity</b></li>
<li><b>Safe & Multicultural</b></li>
</ul>
</>)
  },


};